/**
 * External Dependencies
 */
import 'bootstrap';
import LazyLoad from 'vanilla-lazyload';

if (typeof jQuery=='undefined' || typeof window.jQuery=='undefined') {
    window.jQuery = require('jquery');
}

/*
import helpers
 */
import PluginManager from 'src/plugin-system/plugin.manager';
//import ViewportDetection from 'src/helper/viewport-detection.helper'; 
//import NativeEventEmitter from 'src/helper/emitter.helper';

/*
import plugins
 */
import HeaderPlugin from './plugin/header/header.plugin';
import ReadMorePlugin from './plugin/read-more/read-more.plugin';
import CustomNavPillsPlugin from './plugin/custom-nav-pills/custom-nav-pills.plugin';
//import ContainerAnfragePlugin from './plugin/container-anfrage/container-anfrage.plugin';
import SearchPlugin from './plugin/search/search.plugin';
import AbfallartenSliderPlugin from './plugin/abfallarten-slider/abfallarten-slider.plugin';
import HeroPlugin from './plugin/hero/hero.plugin';
import HeroSliderPlugin, { initHeroSlider } from './plugin/hero-slider/hero-slider.plugin';
import LKWLichterPlugin from './plugin/lkw-lichter/lkw-lichter.plugin';
import SideWidgetPlugin from './plugin/side-widget/side-widget.plugin';
import MobileColorSlidesPlugin from './plugin/mobile-color-slides/mobile-color-slides.plugin';
import HomepageLKWPlugin from './plugin/homepage-lkw/homepage-lkw.plugin';
import EinzugsgebietPunktePlugin from './plugin/einzugsgebiet-punkte/einzugsgebiet-punkte.plugin';
import EinzugsgebietGebietePlugin from './plugin/einzugsgebiet-gebiete/einzugsgebiet-gebiete.plugin';

//window.eventEmitter = new NativeEventEmitter();

/*
initialisation
*/
//new ViewportDetection();
const lazyLoad = new LazyLoad();

/*
register plugins
*/
PluginManager.register('Header', HeaderPlugin, '[data-header]');
PluginManager.register('CustomNavPills', CustomNavPillsPlugin, '[data-custom-nav-pills]');
PluginManager.register('Search', SearchPlugin, '[data-search]');
PluginManager.register('ReadMore', ReadMorePlugin, '[data-read-more]');
//PluginManager.register('ContainerAnfrage', ContainerAnfragePlugin, '[data-container-configurator-widget]');
PluginManager.register('Hero', HeroPlugin, '[data-hero]');
PluginManager.register('HeroSlider', HeroSliderPlugin, '[data-hero-slider]');
PluginManager.register('AbfallartenSlider', AbfallartenSliderPlugin, '[data-abfallarten-slider]');
PluginManager.register('LKWLichter', LKWLichterPlugin, '[data-lkw-lichter]');
PluginManager.register('SideWidget', SideWidgetPlugin, '[data-side-widget]');
PluginManager.register('MobileColorSlides', MobileColorSlidesPlugin, '[data-mobile-color-slides]');
PluginManager.register('HomepageLKW', HomepageLKWPlugin, '[data-homepage-lkw]');
PluginManager.register('EinzugsgebietPunkte', EinzugsgebietPunktePlugin, '[data-einzugsgebiet-punkte]');
PluginManager.register('EinzugsgebietGebiete', EinzugsgebietGebietePlugin, '[data-einzugsgebiet-gebiete]');

/*
run plugins
*/
document.addEventListener('readystatechange', (event) => {
    if (event.target.readyState === 'complete') {
        PluginManager.initializePlugins();
    }
}, false);

/*
Hero-Slider im Elementor-Editor neu starten, wenn das Widget neu gerendert wird
*/
if (window.jQuery) {
    window.jQuery(window).on('elementor/frontend/init', () => {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/hero.default', ($scope) => {
            $scope[0].querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
        });

        // Neu gerenderte Widgets enthalten Bilder, die LazyLoad beim Seitenaufbau noch nicht kannte
        window.elementorFrontend.hooks.addAction('frontend/element_ready/global', () => {
            lazyLoad.update();
        });
    });
}

/*
Elementor popup trigger via [data-popup-trigger="<id>"]
*/
document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-popup-trigger]');
    if (!trigger) return;
    e.preventDefault();
    const id = parseInt(trigger.getAttribute('data-popup-trigger'), 10);
    if (window.elementorProFrontend && window.elementorProFrontend.modules.popup) {
        window.elementorProFrontend.modules.popup.showPopup({ id });
    } else if (window.jQuery) {
        window.jQuery(document).trigger('elementor/popup/show', { id });
    }
});

/*
Accessibility fixes
*/
document.addEventListener('DOMContentLoaded', function() {
    // Fix tabindex > 0 issues (WCAG best practice)
    // Elements should not have tabindex greater than 0
    const elementsWithHighTabindex = document.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
    elementsWithHighTabindex.forEach(function(el) {
        const currentTabindex = parseInt(el.getAttribute('tabindex'), 10);
        if (currentTabindex > 0) {
            el.setAttribute('tabindex', '0');
        }
    });

    // Fix date picker buttons that might appear later
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) {
                    // Fix tabindex on newly added elements
                    const newHighTabindexElements = node.querySelectorAll ?
                        node.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])') : [];
                    newHighTabindexElements.forEach(function(el) {
                        const currentTabindex = parseInt(el.getAttribute('tabindex'), 10);
                        if (currentTabindex > 0) {
                            el.setAttribute('tabindex', '0');
                        }
                    });

                    // Also check the node itself
                    if (node.hasAttribute && node.hasAttribute('tabindex')) {
                        const currentTabindex = parseInt(node.getAttribute('tabindex'), 10);
                        if (currentTabindex > 0) {
                            node.setAttribute('tabindex', '0');
                        }
                    }

                    // Add aria-label to date picker navigation buttons
                    const nextButtons = node.querySelectorAll ?
                        node.querySelectorAll('.next-button:not([aria-label])') : [];
                    nextButtons.forEach(function(btn) {
                        btn.setAttribute('aria-label', 'Nächster Monat');
                    });

                    const prevButtons = node.querySelectorAll ?
                        node.querySelectorAll('.prev-button:not([aria-label])') : [];
                    prevButtons.forEach(function(btn) {
                        btn.setAttribute('aria-label', 'Vorheriger Monat');
                    });
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Fix existing date picker buttons
    document.querySelectorAll('.next-button:not([aria-label])').forEach(function(btn) {
        btn.setAttribute('aria-label', 'Nächster Monat');
    });
    document.querySelectorAll('.prev-button:not([aria-label])').forEach(function(btn) {
        btn.setAttribute('aria-label', 'Vorheriger Monat');
    });

    // Remove invalid aria-expanded from non-interactive elements
    document.querySelectorAll('div[aria-expanded]:not([role])').forEach(function(el) {
        el.removeAttribute('aria-expanded');
    });
}); 